<template>
  <div style="margin-top:10px;">
    <el-row align="bottom">
      <el-col :span="16">
        <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize" layout="prev,pager,next" :total="pageTotal"></el-pagination>
      </el-col>
    </el-row>
    <!-- <el-divider></el-divider> -->
    <el-table :data="tableData" @expand-change="tableChange" :expand-row-keys="expands" row-key="id" stripe border ref="table2" @selection-change="selectionChange">
      <el-table-column type="expand" prop="childdata" size="small">
        <span slot-scope="scopes">
          <el-table :data="orderProductArr" border align="center" stripe>
            <el-table-column prop="warehouseName" label="供应商" width="200">
              <span slot-scope="scope">{{ scope.row.warehouseUserName?scope.row.warehouseUserName:scope.row.supWarehouseCode }}</span>
            </el-table-column>
            <el-table-column prop="productName" label="图书名称" width="330" />
            <el-table-column prop="productSn" label="ISBN" width="230" />
            <el-table-column prop="marketPrice" label="定价" width="120" />
            <el-table-column prop="discount" label="折扣" width="120" />
            <el-table-column prop="shopPrice" label="折扣价" width="120" />
            <el-table-column prop="productNumber" label="数量" width="120" />
             <!-- 
            <el-table-column prop="productAssigned" label="已配送" width="90"/>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="light" content="退款" placement="top">
                  <el-button round size="mini" type="primary" @click="handleReturn(scope.row)" icon="el-icon-sold-out">退款</el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="light" content="退货" placement="top" v-if="scope.row.productAssigned >= 1">
                  <el-button size="mini" type="primary" round @click="handleBack(scope.row)" icon="el-icon-s-release">退货</el-button>
                </el-tooltip> 
              </template>
            </el-table-column>
             -->
          </el-table>
          <div>
            <el-tag type="info" effect="plain">
              <b>收货人</b>：{{ scopes.row.consignee }}&#8195; <b>收货地址</b>：
              {{ scopes.row.provinceText }}
              {{ scopes.row.cityText }}
              {{ scopes.row.districtText }}&#8195;
              {{ scopes.row.address }}&#8195; <b>联系电话</b>：{{ scopes.row.mobile }}&#8195;
            </el-tag>
          </div>
          <div>
            <el-tag type="info" effect="plain">
              <b>客户下单备注</b>：{{ scopes.row.payNote }}
            </el-tag>
          </div>
        </span>
      </el-table-column>
      <el-table-column align="center" width="45" label="全选" type="selection"></el-table-column>
      <el-table-column align="center" prop="orderSn" label="订单编号" ></el-table-column>
      <!-- <el-table-column align="center" label="订单编号">
        <template slot-scope="scope">
          <el-link :underline="false" @click="mergePayOrder(scope.row)">{{scope.row.orderSn}}</el-link>
        </template>
      </el-table-column> -->
      <el-table-column align="center" prop="goodsAmount" label="数量" width="100"></el-table-column>
      <el-table-column align="center" prop="orderMoneyOriginal" width="100" label="定价" ></el-table-column>
      <!-- <el-table-column align="center" prop="discount" label="折扣" width="60"></el-table-column> -->
      <el-table-column align="center" prop="orderMoney" label="折扣价" width="100" ></el-table-column>
      <!-- <el-table-column align="center" prop="expenses" label="运费" width="65"></el-table-column> -->
      <el-table-column align="center" prop="addTime" label="订单时间" width="200"></el-table-column>
      <el-table-column align="center" prop="orderStatus_dictText" label="订单状态" width="100" ></el-table-column>
      <!-- <el-table-column align="center" prop="shippingStatus_dictText" label="发货状态" width="80" ></el-table-column> -->
      <el-table-column align="center" prop="payStatus_dictText" label="付款状态" width="100"></el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <span>
            <el-tooltip class="item" effect="light" content="删除订单" placement="top">
              <el-button size="mini" type="primary" round @click="delOrder(scope.row)" icon="el-icon-delete"></el-button>
            </el-tooltip>
          </span>
        </template>
      </el-table-column>
<!-- 
      <el-table-column align="center" label="付款状态" width="80">
        <template slot-scope="scope">
          <div v-if="scope.row.payStatus !== 2">
            <el-link @click="goPay(scope.row)" :underline="false">
              <mv-count-down @startCallback="countDownS" @endCallback="countDownE(scope.row)" :startTime="startTime" :endTime="endTime" :endText="endText" :isStart="isStart"></mv-count-down>
            </el-link>
            <el-tooltip class="item" effect="light" content="取消订单" placement="top">
              <el-button size="mini" round @click="delOrder(scope.row)" icon="el-icon-delete"></el-button>
            </el-tooltip>
          </div>
          <div v-else>
            {{ scope.row.payStatus_dictText }}
            <span v-if="scope.row.shippingStatus < 1">
              <el-tooltip class="item" effect="light" content="取消订单" placement="top">
                <el-button size="mini" type="primary" round @click="delOrder(scope.row)" icon="el-icon-delete"></el-button>
              </el-tooltip>
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="shippingName" label="快递公司" width="120"></el-table-column>
      <el-table-column align="center" prop="shippingId" label="快递单号"></el-table-column>
       -->
    </el-table>
    <el-dialog title="退货申请" :visible.sync="dialogVisible" width="26%">
      <el-form ref="form" :model="backForm" label-width="80px">
        <el-form-item label="退货数量">
          <el-input v-show="false" v-model="backForm.id" />
          <el-input-number :min="1" :max="backNumberMax" v-model="backForm.backNumber"></el-input-number>
        </el-form-item>
        <el-form-item label="退货原因">
          <el-select v-model="backForm.backType" placeholder="请选择退货原因">
            <el-option label="质量问题" value="1"></el-option>
            <el-option label="其它" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退货说明">
          <el-input type="textarea" v-model="backForm.backDesc"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
        <el-button type="primary" @click="backSubmit">申请退货</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getAction,
  deleteAction,
  downFile,
  postAction,
} from "../../../api/index";
export default {
  name: "orderComplete",
  inject: ['parentQueryParam'],
  data() {
    return {
      tableData: [],
      expands: [],
      multipleSelection: [],
      orderProductArr: [],
      queryParam: {
        isbn: "",
        orderSn: "",
        beginTime: "",
        endTime: "",
      },
      backForm: {
        id: "",
        backNumber: "",
        backType: "",
        backDesc: "",
        backMoney: 0.0,
      },
      url: {
        getorderLit: "/whOrder/queryList",
        selectOrderProductByOrderId: "/whOrder/selectOrderProductByOrderId",
        delOrder: "/whOrder/delete",
        orderProductBack: "/whOrder/orderProductBack",
        exportExcel: "/whOrder/exportExcel",
        mergePayOrder: "/whOrder/mergePayOrder",
      },
      currentPage: 1, // 当前页码
      pagesize: 10, // 每页显示的行数
      pageTotal: 0,
      startTime: new Date().getTime(), // 开始时间（时间戳）
      endTime: 0, // 完成的时间（时间戳）
      endText: "未支付", // 倒计时完成的提示文本
      isStart: false, // 控制倒计时开始的时机（异步请求完成开启）
      dialogVisible: false,
      backNumberMax: 0,
      orderList: {},
      resultOtherData:{},
    };
  },
  components: {},
  computed: {
    ...mapGetters(["isNaName"]),
  },
  mounted() {},
  created() {
    this.getOrderList(1);
  },
  methods: {
    getOrderList(page, isbn, orderSn, beginTime, endTime, consignee, tel, haveRemarkFlag) {
      const that = this
      getAction(that.url.getorderLit, {
        pageNo: page,
        orderStatus: 2,
        whUId: that.$store.state.userInfo.id,
        isbn: isbn,
        orderSn: orderSn,
        createTime_begin: beginTime,
        createTime_end: endTime,
        consignee: consignee,
        tel: tel,
        haveRemarkFlag: haveRemarkFlag,
      }).then((res) => {
        if (res.data.success) {
          console.log("res.data :>> ", res.data);
          // this.tableData = res.data.result.orderListPage.records;
          // this.pageTotal = res.data.result.orderListPage.total;
          // this.expands = res.data.result.expands;
          that.tableData = res.data.result.records;
          that.pageTotal = res.data.result.total;
          that.resultOtherData = res.data.resultOther
        }
      });
    },
    tableChange(row, expandedRows) {
      //订单展开，查询订单里的产品信息
      var that = this;
      if (expandedRows.length) {
        that.expands = [];
        if (row) {
          that.expands.push(row.id); // 每次push进去的是每行的ID
        }
      } else {
        that.expands = []; // 默认不展开
      }
      let id = row.id;
      getAction(this.url.selectOrderProductByOrderId, { 
        id: id, 
        'productSn': this.parentQueryParam.isbn,
        orderSource: '1',
        userId: this.$store.state.userInfo.id
       }).then(
        (res) => {
          if (res.data.success) {
            this.orderProductArr = res.data.result;
            this.$forceUpdate();
          }
        }
      );
    },
    //嵌套表的复选框事件
    // subtableSelectionChange(row) {
    //   this.multipleSelection.push(row.id);
    //   console.log('this.multipleSelection :>> ', this.multipleSelection);
    //   // row.rows.forEach((d) => {
    //   //   d.selected = row.selectAll;
    //   // });
    // },
    delOrder(row) {
      this.$confirm("取消此订单, 是否继续?", "提示", {confirmButtonText: "确定", cancelButtonText: "取消", type: "warning",}).then(() => {
        deleteAction(this.url.delOrder, { id: row.id }).then((res) => {
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "订单已取消！",
            });
            this.loadList(1)
          }
        });
      }).catch(() => {});
    },
    loadList(pageNo){
      let isbn = this.parentQueryParam.isbn;
      let orderSn = this.parentQueryParam.orderSn;
      let createTime_begin = this.parentQueryParam.beginTime;
      let createTime_end = this.parentQueryParam.endTime;
      let consignee = this.parentQueryParam.consignee;
      let tel = this.parentQueryParam.tel;
      let haveRemarkFlag = this.parentQueryParam.haveRemarkFlag;
      this.getOrderList(pageNo, isbn, orderSn, createTime_begin, createTime_end, consignee, tel, haveRemarkFlag);
    },
    // 页面切换方法
    handleCurrentChange(val) {
      // this.getOrderList(val);
      this.loadList(val)
      this.currentPage = val;
    },
    onSubmit() {
      getAction(this.url.getorderLit, {
        pageNo: 1,
        userId: this.$store.state.userInfo.id,
        isbn: this.queryParam.isbn,
        orderSn: this.queryParam.orderSn,
        createTime_begin: this.queryParam.beginTime,
        createTime_end: this.queryParam.endTime,
      }).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.result.records;
          this.pageTotal = res.data.result.total;
          this.tableData.forEach((el) => {
            if (el.payStatus !== 2) {
              this.setEndTime(el.expireTime); //调用定时器
            }
          });
        }
      });
    },
    handleReturn(row) {
      //退款
      console.log("row :>> ", row);
    },
    handleBack(row) {
      //退货
      this.dialogVisible = true;
      this.backForm.id = row.id;
      this.backNumberMax = row.productAssigned;
    },
    backSubmit() {
      postAction(this.url.orderProductBack, this.backForm).then((res) => {
        if (res.data.success) {
          this.$message.success("退货申请成功，等待管理员审批您的退货申请！");
          this.dialogVisible = false;
        }
      });
    },
    subtableSelectionChange(row) {
      this.multipleSelection.push(row.id);

    },
     selectionChange(row) {
          // console.log("selectionChange========",row);
          this.multipleSelection = row;
          this.$emit('selectionChange',this.multipleSelection)
     },
    mergePayOrder() {
      if (this.multipleSelection.length < 1) {
        this.$message.error("请先选中要合并支付的订单再操作！");
        return;
      }
      let ids = this.multipleSelection.join(",");
      getAction(this.url.mergePayOrder, {
        ids: ids,
        userId: this.$store.state.userInfo.id,
      }).then((res) => {
        if (res.data.success) {
          this.$message.success("订单支付成功！");
          // this.getOrderList(this.currentPage);
          this.loadList(this.currentPage)
        }
      });
    },
    toogleExpand(row) {
      let $table = this.$refs.table2;
      $table.toggleRowExpansion(row);
      console.log(this.$route.params.taskId);
    },

    callback() {
      // coding .......
    },
    // 设置结束时间推迟多少秒并转时间戳
    setEndTime(value) {
      let newTime = new Date(value);
      this.endTime = newTime.getTime();
      this.isStart = true;
    },
    exportExcel() {
      let fileName = "京麦通订单";
      downFile(this.url.exportExcel, {
        userId: this.$store.state.userInfo.id,
      }).then((data) => {
        if (!data) {
          this.$message.warning("文件下载失败");
          return;
        }
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          window.navigator.msSaveBlob(
            new Blob([data], { type: "application/vnd.ms-excel" }),
            fileName + ".xls"
          );
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data], { type: "application/vnd.ms-excel" })
          );
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", fileName + ".xls");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      });
    },
    goPay(row) {
      console.log("row :>> ", row);
    },
    countDownS(x) {
      // 开始倒计时回调
      console.log(x);
    },
    countDownE(row) {
      // 结束倒计时回调
      this.callback();
      deleteAction(this.url.delOrder, { id: row.id }).then((res) => {
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "订单在一定时间内未支付，已取消！",
          });
          this.loadList(1)
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>


/*2.展开按钮未点击的样式是加号带边框*/
::v-deep .el-table__expand-icon .el-icon-arrow-right:before {
  color: #000;
  font-size: 18px;
}


$mainColor: #5cadff;
.contentTitle {
  h1 {
    font-weight: normal;
    font-size: 30px;
    color: #757575;
  }
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
  line-height: 36px;
  background: #e5e9f2;
}
.demo-form-inline {
  margin-top: 1%;
}
// .el-col-2{
//     text-align: right !important;
// }
.el-divider {
  margin: 7px 0 !important;
}
.option {
  ul.category {
    float: left;
    height: 22px;
    padding: 10px 0;
    li {
      float: left;
      a {
        font-size: 16px;
        color: #757575;
        &:hover {
          color: $mainColor;
        }
      }
      span {
        margin: 0 20px;
      }
      &:last-child {
        span {
          display: none;
        }
      }
      &.active {
        a {
          color: $mainColor;
        }
      }
    }
  }
}
.header-search {
  float: right;
  form {
    position: relative;
    .searchPart {
      float: left;
      width: 245px;
      height: 50px;
      transition: all linear 0.2s 0s;
      border: 1px solid #e0e0e0;
      border-right: 0;
      box-sizing: border-box;
      input {
        width: calc(100% - 10px);
        height: 100%;
        outline: none;
        padding: 0 0 0 10px;
        &::-webkit-input-placeholder {
          color: #757575;
        }
      }
    }
    &:hover {
      .searchPart {
        border-color: #b0b0b0;
      }
      .sumbitPart {
        button {
          border-color: #b0b0b0;
        }
      }
    }
    .sumbitPart {
      float: left;
      button {
        cursor: pointer;
        width: 50px;
        height: 50px;
        border: 1px solid #e0e0e0;
        box-sizing: border-box;
        background-color: #fff;
        transition: all linear 0.2s 0s;
        span {
          color: #616161;
          font-size: 20px;
        }
      }
      &:hover {
        button {
          background-color: $mainColor;
          border: 1px solid $mainColor;
          span {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
